// extracted by mini-css-extract-plugin
export default {"box":"ActiveTests_box__1yYS1","content":"ActiveTests_content__HoXin"};